// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.filwallet",
    name: "FILWallet",
    homepage: "https://filwallet.co/",
    image_id: "f400f6c2-ca6c-487b-654d-e119af247500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/filwallet-io/id1572930901",
        android: "https://filwallet.co/",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://h5.filwallet.co",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map